import React, { useRef, useState, useEffect } from "react";
import { FaHeart } from "react-icons/fa";
import axios from "axios";
import "../styles/Message.css";
import { ReactComponent as HeartIcon } from '../assets/heart.svg';


const SOCKET_SERVER_URL = process.env.REACT_APP_BACKEND_URL;
const API_SERVER_URL = `${SOCKET_SERVER_URL}/api/chats`;

const Message = ({ sender, text, chatId, messageIndex, liked, onToggleLike }) => {
  const isLoading = text === "Loading...";
  const messageRef = useRef(null);
  const [isLiked, setIsLiked] = useState(liked || false);

  // When the liked prop changes (e.g. from a refresh), sync the local state.
  useEffect(() => {
    setIsLiked(liked || false);
  }, [liked]);

  const toggleLike = async (event) => {
    event.stopPropagation(); 
    const newLikedStatus = !isLiked;
    setIsLiked(newLikedStatus); // Update local state immediately for optimistic UI
    // Call the callback passed from ChatBox to update the global state & backend.
    if (onToggleLike) {
      onToggleLike(messageIndex, newLikedStatus);
    }
  };

  return (
    <div className={`message ${sender} ${isLoading ? "loading" : ""}`} ref={messageRef}>
      <div className={`message-content ${isLiked ? "liked" : ""}`}>
        {isLoading ? (
          <p>{text}</p>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: text }} />
        )}
        {!isLoading && sender === "assistant" && (
          <div className="heart-icon" onClick={toggleLike} >
            <HeartIcon className={`heart ${isLiked ? "liked" : ""}`} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Message;
